import { el, __ } from '../utils/dom.js';

/**
 * StatCard Component (Object props version)
 *
 * @param {Object} props
 * @param {string} props.icon - Emoji or icon character
 * @param {string} props.label - Label text
 * @param {number|string} props.value - Main value
 * @param {number|string} [props.growth] - Growth/new value (e.g., "+30 new")
 * @param {string} [props.variant='primary'] - Color variant (primary, success, warning, error)
 * @param {number} [props.trend] - Trend percentage (positive/negative)
 * @param {string} [props.comparison] - Comparison label (e.g., "vs last week")
 * @returns {HTMLElement}
 */
export default function StatCard({ icon, label, value, growth, variant = 'primary', trend, comparison }) {
    // Determine trend direction and class
    let trendEl = null;
    if (trend !== undefined && trend !== null) {
        const isUp = trend >= 0;
        const trendIcon = isUp ? '↑' : '↓';
        const trendClass = isUp ? 'presszone-comments-widget__trend--up' : 'presszone-comments-widget__trend--down';
        
        trendEl = el('span', { class: `presszone-comments-widget__trend ${trendClass}` }, 
            `${trendIcon} ${Math.abs(trend)}%`
        );
    }
    
    // Comparison element
    const comparisonEl = comparison ? el('span', { class: 'presszone-comments-widget__comparison' }, comparison) : null;
    
    // Meta container (Trend + Comparison)
    const metaEl = (trendEl || comparisonEl) 
        ? el('div', { class: 'presszone-comments-widget__meta' }, trendEl, comparisonEl) 
        : null;

    return el('div', {
        class: `presszone-comments-widget presszone-comments-widget--${variant}`
    },
        el('div', { class: 'presszone-comments-widget__icon' }, icon),
        el('div', { class: 'presszone-comments-widget__content' },
            el('div', { class: 'presszone-comments-widget__value' },
                String(value),
                growth ? el('span', { class: 'presszone-comments-widget__growth' }, '+' + growth + ' ' + __('New', 'comments-press-zone')) : null
            ),
            el('div', { class: 'presszone-comments-widget__label' }, label),
            metaEl
        )
    );
}

/**
 * Render a stat card for dashboards (function version).
 *
 * @param {string} icon - Emoji or icon
 * @param {string|number} value - Stat value
 * @param {string} label - Stat label
 * @param {string} color - Accent color
 * @param {number} trend - Optional trend percentage
 */
export function renderStatCard(icon, value, label, color = 'var(--presszone-comments-primary)', trend = null) {
    return el('div', { class: 'presszone-comments-stat-card' },
        el('div', { class: 'presszone-comments-stat-card__icon', style: { color } }, icon),
        el('div', { class: 'presszone-comments-stat-card__content' },
            el('div', { class: 'presszone-comments-stat-card__value' }, String(value)),
            el('div', { class: 'presszone-comments-stat-card__label' }, label)
        ),
        trend ? el('div', { class: `presszone-comments-stat-card__trend presszone-comments-stat-card__trend--${trend > 0 ? 'up' : 'down'}` },
            trend > 0 ? '↑' : '↓', ' ', Math.abs(trend), '%'
        ) : null
    );
}
